module.exports = __webpack_public_path__ + "static/media/codexplus-login-guide.6d32a698.png";